export const originsTableHeaderResponseWithProps = () => {
  return [
    {
      'Header': 'Nro. DE ORDEN (TEMS)',
      'accessor': 'orderNumber',
      'width': 150,
    },
    {
      'Header': 'ORIGEN',
      'accessor': 'origenEquivalent',
      'width': 150,
    },
  ];
};
